import { keepPreviousData } from "@tanstack/react-query";
import { useCapitalCallReadOnlyDrawdownTableRetrieve } from "gen/endpoints/capital-call/capital-call";
import React from "react";
import { useTranslation } from "react-i18next";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxActions } from "shared/components/table/box/TableBoxActions";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { useTableBoxContext } from "shared/components/table/box/TableBoxContext";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";

export interface CapitalCallDrawdownTableProps {
  fundFamilyId: string;
  fundFamilyEventId: string;
  isEqualizedView?: boolean;
}

export const CapitalCallDrawdownTable: React.FC<
  CapitalCallDrawdownTableProps
> = ({ fundFamilyId, fundFamilyEventId, isEqualizedView }) => {
  const { data: tableData } = useCapitalCallReadOnlyDrawdownTableRetrieve(
    fundFamilyId,
    fundFamilyEventId,
    {
      is_equalized_view: isEqualizedView,
    },
    {
      query: {
        placeholderData: keepPreviousData,
      },
    },
  );
  return (
    <TableBox boxProps={{ flexShrink: 0 }} isFullHeight={false}>
      <CapitalCallDrawdownTableHeader />
      <TableBoxBody>{tableData && <DataTable data={tableData} />}</TableBoxBody>
    </TableBox>
  );
};

const CapitalCallDrawdownTableHeader: React.FC = () => {
  const { t } = useTranslation(["capitalCall"]);
  const { isFullScreen } = useTableBoxContext();
  return isFullScreen ? (
    <TableBoxHeader>
      <TableBoxTitle>{t("capitalCall:useBreakdownOfCall")}</TableBoxTitle>
      <TableBoxActions />
    </TableBoxHeader>
  ) : null;
};

export default CapitalCallDrawdownTable;
